// Article bodies imported from the old WordPress site link to absolute URLs like
// http://leiturascristas.com.br/<slug>/. Articles now live at /artigos/<slug>/,
// so rewrite those links to relative URLs pointing to the current routes.

const LEGACY_LINK_REGEX = /href="https?:\/\/(?:www\.)?leiturascristas\.com\.br(\/[^"#?]*)?([^"]*)"/g;

const CURRENT_ROUTES = ["artigos", "edicao", "edicoes", "edicoes-antigas", "livro", "planos", "minha-conta", "admin"];

export function rewriteLegacyLinks(html: string) {
  return html.replace(LEGACY_LINK_REGEX, (_match, path: string | undefined, suffix: string) => {
    const segments = (path ?? "/").split("/").filter(Boolean);

    if (segments.length === 1 && !CURRENT_ROUTES.includes(segments[0])) {
      return `href="/artigos/${segments[0]}/${suffix}"`;
    }

    return `href="${path ?? "/"}${suffix}"`;
  });
}
